export const NAME = "impersonation";

export const ROLE_MAPPING = {
  merchant_admin: "Owner",
  merchant_admin_non_owner: "Admin",
  merchant_user: "User",
};
